import { cn } from "@/utils";
import agentAvatar from "@/assets/agent_ai.png";

interface AiAgentChatButtonProps {
	onClick: () => void;
	hasUserback?: boolean;
}

export const AiAgentChatButton = ({
	onClick,
	hasUserback,
}: AiAgentChatButtonProps) => {
	return (
		<button
			onClick={onClick}
			aria-label="Open AI Assistant"
			className={cn("ai-chat-fab", hasUserback ? "ai-chat-fab--offset" : "")}
		>
			<div className="ai-chat-fab-inner">
				<img src={agentAvatar} alt="AI Assistant" className="ai-chat-fab-img" />
			</div>
		</button>
	);
};
